// @flow
import * as React from 'react';

import { COLORS } from 'Components/utils/color/colors.js';

import { Icon, type IconName } from 'Components/frameworks/icon/Icon.jsx';

type ComponentProps = {
  icon: IconName,
  children: React.Node,
};

function BookingFormInlineField({ icon, children }: ComponentProps) {
  return (
    <div className="BookingFormInlineField">
      {icon ? (
        <div className="BookingFormInlineField-container BookingFormInlineField-container--icon">
          <Icon
            color={COLORS.BLUE}
            className="BookingFormInlineField-icon"
            name={icon}
            width="1.875rem"
          />
        </div>
      ) : null}
      <div className="BookingFormInlineField-container  BookingFormInlineField-container--texts">
        {children}
      </div>
    </div>
  );
}

export default BookingFormInlineField;
